// ==============================================================================
// SERVIÇO: GESTÃO DE ESTADO E NOTIFICAÇÃO DE USUÁRIO INATIVO
// ==============================================================================

const INACTIVE_NOTICE_KEY = 'voope_inactive_user_notice';

export interface InactiveNoticeData {
  email?: string;
  name?: string;
  timestamp: number;
  message?: string;
}

export const inactiveUserService = {
  /**
   * Registra que o usuário foi bloqueado por inatividade
   */
  setInactiveNotice(email?: string, name?: string, customMessage?: string): void {
    try {
      const data: InactiveNoticeData = {
        email: email || '',
        name: name || '',
        timestamp: Date.now(),
        message: customMessage || 'Sua conta está inativa. Entre em contato com a transportadora para regularizar seu acesso.'
      };
      sessionStorage.setItem(INACTIVE_NOTICE_KEY, JSON.stringify(data));
    } catch (e) {
      console.error('Erro ao salvar aviso de usuário inativo no sessionStorage:', e);
    }
  },

  /**
   * Obtém os dados do aviso de inatividade pendente (se recente nos últimos 30 min)
   */
  getInactiveNotice(): InactiveNoticeData | null {
    try {
      const raw = sessionStorage.getItem(INACTIVE_NOTICE_KEY);
      if (!raw) return null;
      const data: InactiveNoticeData = JSON.parse(raw);
      
      // Expira após 30 minutos
      if (Date.now() - data.timestamp > 30 * 60 * 1000) {
        sessionStorage.removeItem(INACTIVE_NOTICE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  },

  /**
   * Limpa o aviso de inatividade após exibição ou novo login com sucesso
   */
  clearInactiveNotice(): void {
    try {
      sessionStorage.removeItem(INACTIVE_NOTICE_KEY);
    } catch (e) {
      // Ignora erro
    }
  }
};
